import { Step } from "react-joyride";

type StepContent = Pick<Step, "target" | "content">;

export const MAP_ADDRESS_STEP: StepContent = {
  target: ".tour-map-address-window",
  content:
    "Enter the address of your job. If the address is unknown, you may enter an address that is nearby, and adjust in a later step.",
};

export const MAP_PIN_STEP: StepContent = {
  target: ".leaflet-custom-marker-icon",
  content:
    "Now your map has been focused on the designated job area. Here you may adjust the red pin on screen by dragging and dropping it to the exact location of your job.",
};

export const MAP_CHANGE_ADDRESS_STEP: StepContent = {
  target: ".tour-map-change-address",
  content: "Change the address here to move your Pin and view a new area in Maps.",
};

export const MAP_OVERWRITE_ADDRESS_STEP: StepContent = {
  target: ".tour-map-overwrite-address",
  content:
    "Typing here will change the address text shown on the proposal, but does not change the actual job site you've designated on the map. Used particularly when you needed to move a Pin to a location that doesn't have an address (new subdivision for example).",
};

export const MAP_CONFIRM_STEP: StepContent = {
  target: ".tour-map-confirm-address",
  content: "If the location looks good, click here to add it to your proposal and continue.",
};

export const SELECT_PRODUCT_STEP: StepContent = {
  target: ".tour-select-product",
  content: "Select a product you want to add to the proposal.",
};

export const ADD_PRODUCT_STEP: StepContent = {
  target: ".tour-add-product-to-proposal",
  content: "Click to add chosen product(s) and continue.",
};

export const PROPOSAL_FORMAT_STEP: StepContent = {
  target: ".tour-proposal-format",
  content: "Here you can change the format of this proposal which is shown to the customer.",
};

export const MAIN_RECIPIENT_STEP: StepContent = {
  target: ".tour-main-recipient",
  content: "This is the recipient's email from the Contact that was chosen.",
};

export const ADDITIONAL_RECIPIENTS_STEP: StepContent = {
  target: ".tour-additional-recipients",
  content: "You can include additional recipients for the proposal.",
};

export const EMAIL_SETTINGS_STEP: StepContent = {
  target: ".tour-email-settings",
  content:
    "This is the subject line and text of the email being sent to the customer with the proposal link.",
};
